module.exports = __webpack_public_path__ + "static/Muji-319306730c2def6e0997d859bdac109f.webp";